import React from 'react';
import '../assets/css/styles.css';
import "../assets/css/Careers.css";
import HighlightsCarousel from '../components/HighlightsCarousel';
import { LanguageContext } from '../contexts/LanguageContext'; // Import the LanguageContext
import { useContext } from 'react';
import { t } from 'i18next';


const HeroSection = ({ title, subtitle }) => (
  <header className="hero">
    <div className="hero-overlay">
      <h1>{title}</h1>
      <p>{subtitle}</p>
    </div>
  </header>
);

const IntroSection = () => {
  const { t } = useContext(LanguageContext); // Access translations
  return (
  //   <header className="intro">
      <div className="intro-overlay">
        <p> {t.careers_page_description}
        </p>
      </div>
  //   </header>
  );
}


const JobsSection = () => {
  const { t } = useContext(LanguageContext); // Access translations
  const jobData = [
  {
    name: t.job_1_title,
    date: "June 1, 2025 — June 28, 2025",
    description: t.job_1_description,
    responsibilities: ["Conduct routine patrols and monitor activity within assigned areas", "Enforce security protocols and access control procedures", "Report suspicious activities and security breaches", "Respond to emergencies and coordinate with law enforcement when necessary", "Maintain detailed logs and incident reports"]
  },
  {
    name: t.job_2_title,
    date: "June 1, 2025 — June 28, 2025",
    description: t.job_2_description,
    responsibilities: ["Conduct routine patrols and monitor activity within assigned areas", "Enforce security protocols and access control procedures", "Report suspicious activities and security breaches", "Respond to emergencies and coordinate with law enforcement when necessary", "Maintain detailed logs and incident reports"]
  },
  {
    name: t.job_3_title,
    date: "June 1, 2025 — June 28, 2025",
    description: t.job_3_description,
    responsibilities: ["Conduct routine patrols and monitor activity within assigned areas", "Enforce security protocols and access control procedures", "Report suspicious activities and security breaches", "Respond to emergencies and coordinate with law enforcement when necessary", "Maintain detailed logs and incident reports"]
  },
  {
    name: t.job_4_title,
    date: "June 1, 2025 — June 28, 2025",
    description: t.job_4_description,
    responsibilities: ["Conduct routine patrols and monitor activity within assigned areas", "Enforce security protocols and access control procedures", "Report suspicious activities and security breaches", "Respond to emergencies and coordinate with law enforcement when necessary", "Maintain detailed logs and incident reports"]
  },
];

  return (
    <section className="team container">
      <h2 className="section-title">{t.current_openings}</h2>
      <div className="jobs-grid">
        {jobData.map((m) => (
          <article className="jobs-card" key={m.name}>
            <h3>{m.name}</h3>
            <h4>{m.date}</h4>
            <p>{m.description}</p>
          </article>
        ))}
      </div>
    </section>
  );
}

const WhySection = () => {
  const { t } = useContext(LanguageContext); // Access translations
  return (
    <section className="team container">
      <h2 className="section-title">{t.why_work_with_us}</h2>
      <div className="get-involved">
        <p>{t.why_work_with_us_description}</p>
      </div>
    </section>
  );
}

const HowApply = () => {
  const { t } = useContext(LanguageContext); // Access translations
  return (
    <section className="team container">
      <h2 className="section-title">{t.how_to_apply}</h2>
      <div className="get-involved">
        <p>{t.how_to_apply_description}<a href="mailto:careers@3sss.cm">careers@3sss.cm</a>.</p>
      </div>
    </section>
  );
}

export default function Carreers() {
const { t } = useContext(LanguageContext); // Access translations
  return (
    <>
    <HeroSection
    title={t.careers_page_title}
    subtitle=""
    />
    <IntroSection/>
    <JobsSection/>
    <WhySection/>
    <HowApply/>
    <div className="news-section">
        <p>{t.our_blog}</p>
        <h2>
            <span className="highlight">{t.news_section_highlight} </span>{t.news_section_opening}
        </h2>
        <p className="opening">{t.news_section_description}</p>
        <HighlightsCarousel />
    </div>
    </>
  );
}